import axios from "axios";
import baseURL from "./../api";

class BankingPartnersService {
  getBankingPartners() {
    return axios.get(`${baseURL}/banking-partners`);
  }

  updateStatus(id, isActive) {
    return axios.put(`${baseURL}/banking-partners/${id}/status?is_active=${isActive}`);
  }

  deletePartner(id) {
    return axios.delete(`${baseURL}/banking-partners/${id}`);
  }
}

export default new BankingPartnersService();
